export enum ProcessingAndManagedManagementMutations {
    SET_FORM_VALUES = 'SET_FORM_VALUES',
    SET_CONTACT_INFORMATION = 'SET_CONTACT_INFORMATION',
    SET_TYPINGS = 'SET_TYPINGS',
    SET_INCIDENTS = 'SET_INCIDENTS',
}
